<template>
  <div>
    <div v-if="show" class="wxPage">
      <div class="back" @click="onClose" />
      <div class="font" @click="onClose">
        <table>
          <tr>
            <td>
              {{ shareTitle }}
            </td>
            <td>
              <i class="iconfont iconjiantouShare" />
            </td>
          </tr>
        </table>

      </div>
      <div v-if="messageStr" class="message" v-html="messageStr" />
    </div>

  </div>
</template>
<script>
import request from '@/utils/request'
import wx from 'weixin-js-sdk'
import { MyNotify } from '@/utils/base'
// import { unwatchFile } from 'fs'
import globalVariable from '@/api/global_variable.js'
import { GetSelfUrl } from '@/utils/request'
export default {
  components: {
  },
  props: {
    value: Boolean,
    // eslint-disable-next-line
    title: {
      default: '测试'
    },
    // eslint-disable-next-line
    desc: {
      default: '测试描述'
    },
    // eslint-disable-next-line
    timeline:{
      default: '朋友圈'
    },
    // eslint-disable-next-line
    img: {
      default: undefined
    },
    // eslint-disable-next-line
    url: {
      default: undefined
    },
    // eslint-disable-next-line
    message:{
      default: undefined
    },
    // eslint-disable-next-line
    shareTitle: {
      default: '点击这里分享'
    }
  },
  data() {
    return {
      show: false,
      tryNum: 0,
      isCreate: false,
      messageStr: undefined
    }
  },
  watch: {
    img(newValue) {
      console.log('我监听到了img的值', newValue)
      // console.log('img', newValue)
    },
    url(newValue) {
      console.log('我监听到了url的值', newValue)
      // console.log('img', newValue)
    },
    title(newValue) {
      console.log('我监听到了title的值', newValue)
    },
    value(newValue, oldValue) {
      if (newValue) {
        this.show = true
      }
    },
    message(newValue) {
      this.messageStr = newValue
    }
  },
  activated() {
    console.log('分享页面被激活了')
    this.onLoop()
  },
  created() {
    console.log('分享页面被创建了')
    this.onLoop()
  },
  methods: {
    onLoop() {
      // if (this.isCreate) {
      //   return
      // }
      console.log('onLoop')
      var my = this
      setTimeout(() => {
        my.tryInit(my)
      }, 20)
      this.isCreate = true
    },
    onClose() {
      this.show = false
      this.messageStr = undefined
      this.$emit('input', false)
    },
    tryInit(my) {
      my.tryNum++
      // console.log('tryInit', my.url)
      if (my.url) {
        my.init(my)
        return
      }
      if (my.tryNum > 1000) {
        return
      }
      setTimeout(() => {
        my.tryInit(my)
      }, 50)
    },

    init(my) {
      var u = navigator.userAgent
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      var url = location.href.split('#')[0]
      console.log('当前URL：', url)
      // if (window.__wxjs_is_wkwebview) {
      if (isIOS) {
        var baseurl = GetSelfUrl()
        url = baseurl.substring(0, baseurl.length - 1) + globalVariable.IosStartURL
        // alert('我是IOS系统，入口页面地址为:' + url)
      } else {
        // alert('我是Android系统，入口页面地址为:' + url)
      }
      // alert(url)
      // alert("我是IOS系统，入口页面地址为:"+url)
      // }
      console.log('申请签名URL：', url)
      request({
        url: '/data/getWxShare',
        method: 'post',
        data: {
          url: url
        }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        // alert("Response.data.appId："+Response.data.appId)
        // alert("Response.data.timestamp："+Response.data.timestamp)
        // alert("Response.data.nonceStr："+Response.data.nonceStr)
        // alert("Response.data.signature："+Response.data.signature)
        var wxconfig = {
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: Response.data.appId, // 必填，公众号的唯一标识
          timestamp: Number(Response.data.timestamp), // 必填，生成签名的时间戳
          nonceStr: Response.data.nonceStr, // 必填，生成签名的随机串
          signature: Response.data.signature, // 必填，签名，见附录1
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        }
        wx.config(wxconfig)
      })
      wx.error(function(res) {
        //alert(res.errMsg)
      })
      wx.ready(function() {
        var links = my.url
        var title = my.title
        console.log('分享标题：', title)
        var desc = my.desc
        var imgUrl = my.img
        var timeline = my.timeline
        my.$emit('onFinish')
        my.isCreate = false
        var successcallback = function() {
          MyNotify('success', '分享成功')
          my.onClose()
        }
        var cancelcallback = function() {
          my.onClose()
        }
        var initShareStr = function() {
          wx.onMenuShareTimeline({
            title: timeline, // 分享标题
            link: links, // 分享链接,将当前登录用户转为puid,以便于发展下线
            imgUrl: imgUrl, // 分享图标
            success: successcallback,
            cancel: cancelcallback
          })
          wx.onMenuShareAppMessage({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: links, // 分享链接
            imgUrl: imgUrl, // 分享图标
            type: 'link', // 分享类型,music、video或link，不填默认为link
            success: successcallback,
            cancel: cancelcallback
          })
          wx.onMenuShareQQ({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: links, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: successcallback,
            cancel: cancelcallback
          })
          wx.onMenuShareWeibo({
            title: title, // 分享标题
            desc: desc, // 分享标题
            link: links, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: successcallback,
            cancel: cancelcallback
          })
          wx.onMenuShareQZone({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: links, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: successcallback,
            cancel: cancelcallback
          })
        }
        initShareStr()
        setTimeout(() => {
          initShareStr()
        }, 1000)
        setTimeout(() => {
          initShareStr()
        }, 2000)
        setTimeout(() => {
          initShareStr()
        }, 3500)
        setTimeout(() => {
          initShareStr()
        }, 5000)
      })
    }
  }
}
</script>
<style scoped>
.wxPage{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 111111;
}
.wxPage .back{
    width: 100%;
    height: 100%;
    background-color: #000 ;
    -moz-opacity:0.8;
    opacity: 0.8;
}
.font{
    position: fixed;
    right: 1em;
    top: 1em;
    left: 1em;
     z-index: 111112;
     color: #fff;
     text-align: right;
}
.font table{
  float: right;
}
.font i{
    font-size: 4em;
}
.message{
  position:absolute;
  top: 40%;
  padding: 0 1em;
  color: #fff;
}
</style>
